import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const DropzoneContainer = styled(Box)(({ theme, isdragactive, disabled }) => ({
    border: '2px dashed gray',
    borderRadius: '8px',
    padding: theme.spacing(5),
    textAlign: 'center',
    backgroundColor: disabled ? '#f5f5f5' : (isdragactive === 'true' ? '#f0f0f0' : '#fff'),
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    width: '60%',
    maxWidth: 600,
    margin: '40px auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
}));

export const DropzoneText = styled(Typography)(({ theme }) => ({
    ...theme.typography.body1,
}));

export const PreviewContainer = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    justifyContent: 'center',
}));

export const PreviewImage = styled('img')(() => ({
    width: 100,
    height: 100,
    objectFit: 'cover',
    borderRadius: 4,
    border: '1px solid #ccc',
}));
